import {
  CUSTOMER_SEGMENTS,
  LogoMarquee,
} from "@/components/products/shared/CustomerSegments"

const CustomerGrid = () => {
  return (
    <div
      className="flex flex-col gap-2 items-center py-16 animate-fade-in-up"
      style={{
        opacity: 0,
        animationDelay: "0.5s",
      }}
    >
      <div className="text-fg-secondary text-base mb-4 lg:mb-6 max-w-[490px]">
        Trusted by
      </div>
      <div className="flex flex-col w-full border-t border-border-default">
        {CUSTOMER_SEGMENTS.map((segment, i) => (
          <section
            key={segment.label}
            className="grid grid-cols-1 md:grid-cols-[200px_1fr] items-center gap-x-8 border-b border-border-default py-2"
          >
            <div className="text-sm text-fg-secondary pt-2 md:pt-0">
              {segment.label}
            </div>
            <LogoMarquee
              logos={segment.logos}
              reverse={i % 2 === 1}
              className="min-w-0"
            />
          </section>
        ))}
      </div>
    </div>
  )
}

export default CustomerGrid
